import { Navigate } from "react-router-dom";
import GlobalSidebar from "../Components/Navigations/Sidebar/Sidebar";
import { selectIsProviderLoggedIn } from "../Store/Provider/selectors";
import { useAppSelector } from "../Store/Hooks";

interface ProtectedRouteProps {
    children: JSX.Element;
    isSideBar: boolean;
}

export const ProtectedRoute = ({ children, isSideBar }:ProtectedRouteProps) => {
  const isLoggedIn = useAppSelector(selectIsProviderLoggedIn);
  if (!isLoggedIn) {
    // user is not authenticated
    return <Navigate to="/" />;
  }
  return (
    <>
        {isSideBar && <GlobalSidebar></GlobalSidebar>}
        {children}
    </>
  );
};